import { VOLUME_KEY } from "../../../types/GameTypes";

export type Sound =
  | "ACTIVATE"
  | "BEEP_BEEP"
  | "BONK"
  | "CALYPSO"
  | "DEACTIVATED"
  | "DETOUR"
  | "DRAMA"
  | "DRUMSET"
  | "DUDUN"
  | "EXPLOSION"
  | "GAME_OVER"
  | "GONG"
  | "HIT"
  | "MESSAGE"
  | "PLACED"
  | "POWERUP"
  | "REFLECTION"
  | "RAY"
  | "REMOVED"
  ;

const media: { [string: string]: string } = {
  ACTIVATE: require("./sounds/activate.mp3"),
  BEEP_BEEP: require("./sounds/beep-beep.mp3"),
  BONK: require("./sounds/bonk.mp3"),
  CALYPSO: require("./sounds/calypso.mp3"),
  DEACTIVATED: require("./sounds/deactivated.mp3"),
  DETOUR: require("./sounds/detour.mp3"),
  DRAMA: require("./sounds/drama.mp3"),
  DRUMSET: require("./sounds/drumset.mp3"),
  DUDUN: require("./sounds/dudun.mp3"),
  EXPLOSION: require("./sounds/explode.mp3"),
  GONG: require("./sounds/gong.mp3"),
  HIT: require("./sounds/hit.mp3"),
  MESSAGE: require("./sounds/message.mp3"),
  PLACED: require("./sounds/placed.mp3"),
  POWERUP: require("./sounds/powerup.mp3"),
  REFLECTION: require("./sounds/reflection.mp3"),
  RAY: require("./sounds/ray.mp3"),
  REMOVED: require("./sounds/removed.mp3"),
};

export const DEFAULT_VOLUME = 5;

const getVolume = (): number => {
  const value = window.localStorage.getItem(VOLUME_KEY!);
  return value ? +value : DEFAULT_VOLUME;
};

export function play(sound: string) {
  const audio = new Audio(media[sound]);
  audio.volume = getVolume() / 10;
  audio.play().catch(() => {
    console.warn(`playing sound ${sound} failed.`);
    // if sound fails, we just want to be quiet about it (pun absolutely intended)
  });
}

export default play;
